import axios from "axios";
import { useState } from "react";
import { ClipLoader } from "react-spinners";
import Swal from "sweetalert2";
import "../Services/Service.css";
import ServiceRegisterNoAuth from "./service-no-auth";
import getToken from "../../hooks/getToken";
import { useLanguage } from "../../store/language-context";
import { useTranslation } from "react-i18next";

const ServiceApplyBtn = ({ serviceId, serviceName }) => {
  const { URL } = useLanguage();
  const [noAuthSeen, setNoAuthSeen] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const token = getToken();
  const { t } = useTranslation();
  const togglePopup = async () => {
    if (token) {
      setLoading(true);
      try {
        const response = await axios.post(
          `${URL}/service-register-auth`,
          {
            service_id: serviceId
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            }
          }
        );
        if (response.status === 200) {
          Swal.fire({
            icon: 'success',
            title: t('custom.done-check'),
            confirmButtonText: t('custom.accept')
          });
        }
        // If we got here, the request was successful with status 200
      } catch (error) {
        if (error.response) {
          if (error.response.status === 401) {
            // Handle unauthorized access
            Swal.fire({
              icon: 'error',
              title: t('custom.failed'),
              text: t('custom.login-first'),
              confirmButtonText: t('custom.accept')
            });
          } else if (error.response.status === 409) {
            // Handle already registered
            Swal.fire({
              icon: 'info',
              title: t('custom.old-check'),
              confirmButtonText: t('custom.accept')
            });
          } else {
            // Handle other API errors
            Swal.fire({
              icon: 'error',
              title: t('custom.failed'),
              text: error.response.data?.message || t('custom.err'),
              confirmButtonText: t('custom.accept')
            });
          }
        } else {
          // Handle network errors or other issues
          Swal.fire({
            icon: 'error',
            title: t('custom.failed'),
            text: t('custom.err'),
            confirmButtonText: t('custom.accept')
          });
        }
      } finally {
        setLoading(false);
      }
    } else {
      setNoAuthSeen(true);
    }
  };

  return (
    <>
      <div className="order-section wow slideInUp mt-4 z-[999999999999]" data-wow-duration="3s">
        <button
          onClick={togglePopup}
          className={`button popupbutton ${isLoading ? 'loading' : ''}`}
          disabled={isLoading}
        >
          {isLoading ? <ClipLoader size={20} color={"#ffffff"} /> :
            <span className="one">
              {t('leadership.order-now')}
            </span>}
        </button>
      </div>
      {
        noAuthSeen &&
        <ServiceRegisterNoAuth
          setState={setNoAuthSeen}
          isService={true}
          serviceName={serviceName}
          serviceId={serviceId}
        />
      }
    </>
  );
};

export default ServiceApplyBtn;